import { api } from "@/APIRequests";
import type { PatientDetails } from "@/core/types";

export async function getPatientDetails(patientId: string): Promise<PatientDetails> {
  const response = await api.sharedTyped.fetch_patient_details({
    params: { showLoader: false },
    patientId,
  });

  return response.user;
}
